import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './APIFDFSectionSkeleton.styles.scss';

const APIFDFSectionSkeleton: React.FC = () => {
  return (
    <div className="apifdf-section-skeleton">
      {/* Title Skeleton */}
      <Skeleton
        width="20rem"
        height="1.5rem"
        style={{ marginBottom: '1.5rem', margin: '0 auto' }}
      />

      {/* TabView Header Skeleton */}
      <div className="apifdf-tabs-skeleton">
        <Skeleton width="8rem" height="2.5rem" borderRadius="0.5rem" />
        <Skeleton width="8rem" height="2.5rem" borderRadius="0.5rem" />
      </div>

      {/* DataTable Skeleton */}
      <div className="apifdf-table-skeleton">
        {/* Table Header */}
        <div className="apifdf-table-header-skeleton">
          {Array.from({ length: 6 }).map((_, index) => (
            <Skeleton key={index} width="100%" height="2rem" />
          ))}
        </div>

        {/* Table Rows */}
        {Array.from({ length: 5 }).map((_, rowIndex) => (
          <div key={rowIndex} className="apifdf-table-row-skeleton">
            {Array.from({ length: 6 }).map((_, colIndex) => (
              <Skeleton key={colIndex} width="100%" height="1.5rem" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default APIFDFSectionSkeleton;

